import { PropsWithChildren } from "react";
import { useTranslation, Trans } from "react-i18next";
import { TopNav } from "./TopNav";
import { BottomNav } from "./BottomNav";
import { SubscriptionBanner } from "./SubscriptionBanner";
import { InstallBanner } from "@/components/InstallBanner";

export function AppShell({ children }: PropsWithChildren) {
  const { t } = useTranslation();
  return (
    <div className="min-h-dvh bg-cream">
      <SubscriptionBanner />
      <TopNav />
      {/* Responsive navigation: sticky top bar on md+, floating bottom pill on mobile. */}
      <BottomNav />
      <main className="mx-auto w-full max-w-md px-4 pb-28 pt-4 sm:max-w-3xl sm:px-6 sm:pb-12 md:pt-6 lg:max-w-5xl lg:px-8 xl:max-w-7xl xl:px-10 2xl:max-w-[1800px] 2xl:px-12">
        {children}
      </main>
      <InstallBanner />
      {/* Phase32: intervals.icu API Terms 1.1 — wearable / Garmin attribution. */}
      <footer className="mx-auto w-full max-w-3xl px-4 pb-10 pt-4 sm:max-w-3xl">
        <div className="footer-legal-note">
          <Trans
            i18nKey="device_attribution.footer_powered_by_prefix"
            t={t}
          />{" "}
          <a
            href="https://intervals.icu"
            target="_blank"
            rel="noopener noreferrer"
          >
            intervals.icu
          </a>
          . {t("device_attribution.footer_garmin_note")}
        </div>
      </footer>
    </div>
  );
}
